import { AdminPermissionsSystemValues, ApplicationPermissionsSystemValues } from '@fluentsms/types-fluent';
import { useMemo } from 'react';
import { useAuth } from '../auth';

type UseAuthorizedAnywhereReturn = {
  isAuthorized: boolean;
};

export const useHasAuthorizedAnywhere = (
  authorizationTarget: AdminPermissionsSystemValues | ApplicationPermissionsSystemValues,
): UseAuthorizedAnywhereReturn => {
  const { hasAuthorizedAnywhere } = useAuth();

  const isAuthorized = useMemo(
    () => hasAuthorizedAnywhere(authorizationTarget),
    [authorizationTarget, hasAuthorizedAnywhere],
  );

  return { isAuthorized };
};
